import React, { useState } from 'react'
import './Community.css'
import Select from 'react-select';


export default function CreatePost({ handleFalseCreatePost }) {

    // drodowon css
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            height: '38px',
            width: '100%',
            borderRadius: '6px',
            padding: ' 1px',
            border: '1px solid #99ADBB',
            fontFamily: "MinecrafterReg.ttf",
            background: 'white',
            fontSize: '12px'
        }),
        menu: (provided, state) => ({
            ...provided,
            // width: state.selectProps.menuWidth || 'auto', // Set the width to 10px when menuWidth is set
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: 'white',
            fontSize: '12px',
            color: 'black', // Change the background color when the option is hovered over
            '&:hover': {
                boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
                color: '#F77F00',
                borderRadius: '5px',
                fontWeight: '600'

            },
        }),
        indicatorSeparator: () => ({ display: "none" }),

    };
    const optionsQuery = [
        { value: 'Name', label: ' Name' },
        { value: 'Tag', label: ' Tag' },

    ];
    const [selectedOption, setSelectedOption] = useState(null);
    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);
    };


    // function add tag 
    const optionsaddTag = [
        { value: 'Exhibition', label: ' Exhibition' },
        { value: 'Social Expo 2022', label: ' Social Expo 2022' },
    ];
    const [selectedTagOption, setSelectedTagOption] = useState(null);
    const handleTagChange = (selectedTagOption) => {
        setSelectedTagOption(selectedTagOption);
    };

    return (
        <div className='ContainerCreatePostCommunity'>
            <div className='SubContainerCreatePostCommunity'>
                <div>
                    <img onClick={handleFalseCreatePost} style={{ cursor: 'pointer' }} className='CrossIconPost' src='/Enggagement/crossCirclePost.png' alt=''></img>
                </div>
                <div className='d-flex justify-content-between '>
                    <div className='creatPostHeaidng' >Create new post</div>
                    <div className='d-flex align-items-center gap-2'>
                        <div>
                            <img src='/Enggagement/ProifleCommunity.png' alt='' />
                        </div>
                        <div className='nameUser'>
                            Xploresense School
                        </div>
                    </div>
                </div>

                <div className='mt-4 '>
                    <Select
                        options={optionsQuery}
                        value={selectedOption}
                        onChange={handleChange}
                        placeholder="Select Channel"
                        styles={customStyles}
                        classNamePrefix="custom-select" // Add a custom class prefix
                    />
                </div>
                <div className='mt-3'>
                    <Select
                        options={optionsaddTag}
                        value={selectedTagOption}
                        onChange={handleTagChange}
                        placeholder="Add Tags"
                        styles={customStyles}
                        isMulti
                    />
                </div>
                <div className='mt-3'>
                    <textarea className='DescriptiontextCreatePost' placeholder='Add Tags' />
                </div>

                <div className='d-flex justify-content-between mt-3 align-items-center'>
                    <div className='pt-2'>
                        <input type="file" id="attachFile" accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx,.mp3,.mp4" style={{ display: "none" }} />
                        <label htmlFor="attachFile">
                            <div className='d-flex align-items-center gap-1'>
                                <div>
                                    <img src='/Enggagement/AttachIcon.png' alt='' />
                                </div>
                                <div className='attachFileText'>Attach File</div>
                            </div>
                        </label>
                    </div>
                    <div>
                        <button className='PostComunityBtn'>Post</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
